import React, { useState, useEffect } from "react";

export default function InvoiceSection({ company, onInvoiceDataChange }) {
  const [email, setEmail] = useState(company.email || "");
  const [address, setAddress] = useState(company.location || "");
  const [phone, setPhone] = useState(company.phone || "");

  // Form değişikliklerini üst bileşene bildir
  useEffect(() => {
    if (onInvoiceDataChange) {
      const isFormValid = email && address && phone;
      const invoiceData = {
        email,
        address,
        phone,
        companyName: company.company_id || "",
        taxNumber: company.taxInfo?.taxNumber || "",
        taxCity: company.taxInfo?.taxCity || "",
        taxOfficeName: company.taxInfo?.taxOfficeName || "",
        isValid: isFormValid
      };
      onInvoiceDataChange(invoiceData);
    }
  }, [email, address, phone, company, onInvoiceDataChange]);

  // Formun geçerli olup olmadığını kontrol et
  const isFormValid = email && address && phone;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Fatura Bilgileri</h2>
        <div style={styles.infoTag}>Zorunlu alanlar</div>
      </div>

      <div style={styles.card}>
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Şirket Bilgileri</h3>
          <div style={styles.companyInfo}>
            <div style={styles.companyName}>
              {company.company_id || "Şirket bilgisi bulunamadı"}
            </div>
            
            <div style={styles.infoGrid}>
              <div style={styles.infoItem}>
                <span style={styles.label}>Vergi Numarası</span>
                <span style={styles.value}>
                  {company.taxInfo?.taxNumber || "Belirtilmemiş"}
                </span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.label}>Vergi İli</span>
                <span style={styles.value}>
                  {company.taxInfo?.taxCity || "Belirtilmemiş"}
                </span>
              </div>
              
              <div style={styles.infoItem}>
                <span style={styles.label}>Vergi Dairesi</span>
                <span style={styles.value}>
                  {company.taxInfo?.taxOfficeName || "Belirtilmemiş"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style={styles.divider}></div>

        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>İletişim Bilgileri</h3>
          <div style={styles.form}>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>
                Telefon Numarası
                <span style={styles.required}>*</span>
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="(5xx) xxx xx xx"
                style={styles.input}
                required
              />
              {!phone && <div style={styles.errorText}>Bu alan zorunludur</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.formLabel}>
                E-posta Adresi
                <span style={styles.required}>*</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@firma.com"
                style={styles.input}
                required
              />
              {!email && <div style={styles.errorText}>Bu alan zorunludur</div>}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.formLabel}>
                Açık Adres
                <span style={styles.required}>*</span>
              </label>
              <textarea
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Mahalle, sokak, bina no, kat, daire, ilçe / il"
                style={styles.textarea}
                rows={3}
                required
              />
              {!address && <div style={styles.errorText}>Bu alan zorunludur</div>}
            </div>
          </div>
        </div>

        <div style={styles.validationMessage}>
          {isFormValid ? (
            <div style={styles.validMessage}>
              ✓ Tüm zorunlu alanlar dolduruldu
            </div>
          ) : (
            <div style={styles.invalidMessage}>
              ⚠ Ödeme yapabilmek için tüm zorunlu alanları doldurun
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#111827",
    margin: "0",
  },
  infoTag: {
    fontSize: "12px",
    color: "#6B7280",
    backgroundColor: "#F3F4F6",
    padding: "4px 10px",
    borderRadius: "4px",
    fontWeight: "500",
  },
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    padding: "24px",
    backgroundColor: "#FFFFFF",
  },
  section: {
    marginBottom: "24px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#374151",
    margin: "0 0 16px 0",
  },
  companyInfo: {
    backgroundColor: "#F9FAFB",
    borderRadius: "6px",
    padding: "16px",
  },
  companyName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
    marginBottom: "16px",
    paddingBottom: "16px",
    borderBottom: "1px solid #E5E7EB",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
  },
  infoItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  label: {
    fontSize: "12px",
    color: "#6B7280",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  value: {
    fontSize: "14px",
    color: "#111827",
    fontWeight: "500",
  },
  divider: {
    height: "1px",
    backgroundColor: "#E5E7EB",
    margin: "24px 0",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  formLabel: {
    fontSize: "14px",
    color: "#374151",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  required: {
    color: "#DC2626",
    fontSize: "14px",
  },
  input: {
    padding: "12px 16px",
    borderRadius: "6px",
    border: "1px solid #D1D5DB",
    fontSize: "14px",
    color: "#111827",
    backgroundColor: "#FFFFFF",
    transition: "border-color 0.2s",
  },
  textarea: {
    padding: "12px 16px",
    borderRadius: "6px",
    border: "1px solid #D1D5DB",
    fontSize: "14px",
    color: "#111827",
    backgroundColor: "#FFFFFF",
    resize: "vertical",
    minHeight: "80px",
    transition: "border-color 0.2s",
    fontFamily: "inherit",
  },
  errorText: {
    fontSize: "12px",
    color: "#DC2626",
    marginTop: "4px",
  },
  validationMessage: {
    marginTop: "24px",
    paddingTop: "16px",
    borderTop: "1px solid #E5E7EB",
  },
  validMessage: {
    fontSize: "14px",
    color: "#059669",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  invalidMessage: {
    fontSize: "14px",
    color: "#DC2626",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};